var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFooterCasaLupitaLogo = function SvgFooterCasaLupitaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 768 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg",
    x1: -1.95,
    y1: 51.47,
    x2: 317.82,
    y2: 51.47,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 411.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e5ac40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e46929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg-2",
    x1: -1.95,
    y1: 51.34,
    x2: 317.82,
    y2: 51.34,
    xlinkHref: "#f-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg-3",
    x1: -1.95,
    y1: 51.45,
    x2: 317.82,
    y2: 51.45,
    xlinkHref: "#f-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg-4",
    x1: -1.95,
    y1: 51.34,
    x2: 317.82,
    y2: 51.34,
    xlinkHref: "#f-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg-5",
    x1: -1.95,
    y1: 51.34,
    x2: 317.82,
    y2: 51.34,
    xlinkHref: "#f-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg-6",
    x1: -1.95,
    y1: 50.95,
    x2: 317.82,
    y2: 50.95,
    xlinkHref: "#f-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg-7",
    x1: -1.61,
    y1: 51.34,
    x2: 318.16,
    y2: 51.34,
    xlinkHref: "#f-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f-lg-10",
    x1: -1.61,
    y1: 51.34,
    x2: 318.16,
    y2: 51.34,
    xlinkHref: "#f-lg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logo-w"
  }, /*#__PURE__*/React.createElement("g", {
    className: "left-w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.9,356.8h-5.6c-1.6,0-2.9-1.3-2.9-2.9v-81.3c0-1.6,1.3-2.9,2.9-2.9h5.6c1.6,0,2.9,1.3,2.9,2.9v81.3                 C339.8,355.5,338.5,356.8,336.9,356.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.7,
    y: 303,
    className: "st0",
    width: 2.6,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.3,
    y: 310.1,
    className: "st0",
    width: 3.1,
    height: 9.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "right-w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.3,269.7h5.6c1.6,0,2.9,1.3,2.9,2.9v81.3c0,1.6-1.3,2.9-2.9,2.9h-5.6c-1.6,0-2.9-1.3-2.9-2.9v-81.3                 C479.5,271,480.8,269.7,482.3,269.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.9,
    y: 303.1,
    className: "st0",
    width: 2.6,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.9,
    y: 309.2,
    className: "st0",
    width: 3.1,
    height: 9.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "yellow-c",
    d: "M409.6,144.3c-15.1,0-27.3,12.4-27.3,27.7s12.2,27.7,27.3,27.7s27.3-12.4,27.3-27.7         C437,156.7,424.7,144.3,409.6,144.3z M409.6,185.4c-7.3,0-13.3-6-13.3-13.3s6-13.3,13.3-13.3c7.3,0,13.3,6,13.3,13.3         S417,185.4,409.6,185.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "red-c",
    d: "M339.7,83.5c-17.4,0-31.5,14.3-31.5,31.9s14.1,31.9,31.5,31.9s31.5-14.3,31.5-31.9S357.1,83.5,339.7,83.5z         M339.7,130.5c-8.4,0-15.1-6.8-15.1-15.1c0-8.4,6.8-15.1,15.1-15.1c8.4,0,15.1,6.8,15.1,15.1C354.9,123.8,348.1,130.5,339.7,130.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "blue-c",
    d: "M417.8,38.8c-19,0-34.5,15.7-34.5,35s15.4,35,34.5,35c19,0,34.5-15.7,34.5-35S436.8,38.8,417.8,38.8z M417.8,90         c-9,0-16.2-7.3-16.2-16.2s7.2-16.2,16.2-16.2S434,64.9,434,73.8S426.7,90,417.8,90z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logo-part red-p",
    d: "M290.1,359c0,0.8-0.9,1.3-1.6,1c-22.6-11.3-16.9-32.5-17.4-54.1c-0.1-28.5,0.1-47.4,1-86.4         c-0.6-46.2,56.3-80.7,96.3-56.1c0.3,0.2,0.5,0.5,0.5,0.9c0,2.8,0.2,15.1,0.3,20.5c0,0.9-1.1,1.4-1.8,0.8         c-25.8-22.5-76.1-6.5-76.3,34.2C289.6,274.8,290.1,310.1,290.1,359z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "logo-part blue-p",
    d: "M440.1,114.3c0-0.6,0.5-1.1,1.2-1.1c32.4,1.3,60.4,29.7,60,62.9c0.8,37.7,1.1,42.7,1,68.5c0,1-1.2,1.4-1.9,0.7         L482.6,226c-0.2-0.2-0.2-0.4-0.2-0.7v-48.9c-0.2-25.6-20.1-42.4-41.3-43.1c-0.5,0-0.9-0.5-0.9-1L440.1,114.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "logo-part yellow-p",
    d: "M474,270.9c-0.5-21-13.6-40.7-34.3-51.4c0,0-0.1,0-0.1-0.1c-9.3-5-19.6-7.5-30-7.4c-10.4-0.1-20.7,2.4-30,7.4         c0,0-0.1,0-0.1,0.1c-20.7,10.7-33.8,30.4-34.3,51.4c-0.8,35.8-1.1,43.9-0.9,70v2.4c0,4.8,4.2,8.7,9.4,8.7c5.2,0,9.4-3.9,9.4-8.7         v-2.5c-0.1-25.9,0.1-34,0.9-69.6c0.3-14.9,9.8-28.9,24.6-36.6c6.8-3.5,13.9-5.3,20.9-5.3c7,0.1,14.2,1.8,20.9,5.3         c14.9,7.7,24.3,21.7,24.6,36.6c0.8,35.6,1.1,43.7,0.9,69.6v2.4c0,4.8,4.2,8.7,9.4,8.7c5.2,0,9.4-3.9,9.4-8.7v-2.4         C475.1,314.8,474.8,306.7,474,270.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "RedPath_2_",
    className: "mp mp1",
    d: "M340.3,115.4c-55.7,0-54.9,177.3,69.3,177.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "YellowPath_2_",
    className: "mp mp2",
    d: "M411.5,172c-55.7,0-54.9,177.3,69.3,177.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "BluePath_2_",
    className: "mp mp3",
    d: "M417.1,73.5c-55.8,0-54.9,177.3,69.3,177.3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "logo-text",
    transform: "translate(220, 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.35,366.66a15.29,15.29,0,0,1-5.22,10.9q-4.78,3.84-12.55,3.84-9,0-13.82-5.46Q0,370.75,0,360.52q0-10.44,4.88-15.66,4.95-5.44,14.39-5.46,7.68,0,12.2,3.84,4.29,3.7,4.88,10.44h-5a4,4,0,0,1-4-2.44,11.73,11.73,0,0,0-2-2.66,10,10,0,0,0-6.18-1.74c-3.55,0-6.31,1.16-8.24,3.49s-2.79,5.73-2.79,10.22q0,6.49,2.79,10c1.78,2.4,4.45,3.59,8,3.59a9.75,9.75,0,0,0,6.15-1.86,9.73,9.73,0,0,0,3.13-5.61Z",
    fill: "url(#f-lg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.09,340.54h6.5l14.52,40H66.4l-2.67-8.25H48.16l-2.57,8.25H36.9l13.24-37.32A3.91,3.91,0,0,1,54.09,340.54Zm1.86,8-5.58,16.95H61.52Z",
    fill: "url(#f-lg-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.59,368.07h8.13A6.41,6.41,0,0,0,85.39,373a11,11,0,0,0,6.38,1.64,9.65,9.65,0,0,0,5.46-1.28,4.23,4.23,0,0,0,1.86-3.71q0-3.72-10.45-6l-.23-.12-.93-.24q-5.94-1.26-7.92-2.66a6.87,6.87,0,0,1-3.25-3.74,10.65,10.65,0,0,1-1.17-5.34,10.94,10.94,0,0,1,4-8.92q4-3.14,11.5-3.13,7.07,0,10.9,3.25a12.94,12.94,0,0,1,4.17,9.41h-4.59a4,4,0,0,1-3.84-2.44,5.66,5.66,0,0,0-1.62-2,9.53,9.53,0,0,0-5.69-1.51c-2.32,0-4,.43-5,1.28A4.21,4.21,0,0,0,83.23,351c0,2.1,2.24,3.64,6.74,4.65a20.75,20.75,0,0,0,2.9.7c1.39.47,2.61.83,3.66,1.1l2.5.64,3.25,1.39a10,10,0,0,1,3.6,3.61,11.36,11.36,0,0,1,1.27,5.34q0,6.27-4.18,9.75-4.18,3.24-11.89,3.25-7.92,0-11.89-3.37Q74.93,374.7,74.59,368.07Z",
    fill: "url(#f-lg-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.72,340.54h6.52l14.51,40H137l-2.67-8.25H118.81l-2.56,8.25h-8.71l13.24-37.27A3.89,3.89,0,0,1,124.72,340.54Zm1.87,8L121,365.51h11.15Z",
    fill: "url(#f-lg-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,380.54V344.72a4.17,4.17,0,0,1,4.15-4.18h4.1v32.51h19.5v7.49Z",
    fill: "url(#f-lg-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.54,340.42v25c0,3.1.59,5.39,1.75,6.85s3.14,2.17,5.94,2.09,4.63-.69,6-2.09,1.86-3.67,1.86-6.85v-25h8.25v25.91q0,7.43-4.18,11.25-3.84,3.84-11.9,3.84t-11.89-3.84q-4.17-3.82-4.18-11.25V344.86a4.42,4.42,0,0,1,1.22-3.08,3.89,3.89,0,0,1,3-1.34Z",
    fill: "url(#f-lg-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.53,366.21v14.33h-8.25V344.72a4.16,4.16,0,0,1,4.14-4.18h13.63q6.39,0,9.52,3.25t3.25,9.64q0,6-3.13,9.53-3.13,3.24-9.06,3.25Zm0-7.21h8c2.17,0,3.72-.45,4.65-1.39a5.91,5.91,0,0,0,1.51-4.4,5,5,0,0,0-4.08-5.7,4.83,4.83,0,0,0-1.61,0h-8.48Z",
    fill: "url(#f-lg-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.53,380.54V344.72a4.16,4.16,0,0,1,4.14-4.18h4.1v40Z",
    fill: "url(#f-lg-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.34,380.54V347.63h-11.8v-2.91a4.16,4.16,0,0,1,4.14-4.18h27.68v7.09H290.59v32.91Z",
    fill: "url(#f-lg-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.07,340.54h6.5l14.52,40h-8.71l-2.68-8.25H309.19l-2.6,8.25h-8.71l13.29-37.32A3.9,3.9,0,0,1,315.07,340.54Zm1.86,8-5.57,16.95H322.5Z",
    fill: "url(#f-lg-10)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "logo-stext",
    transform: "translate(220, 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37,398.84h5.88c1.83,0,3.51.64,3.51,2.91a2.65,2.65,0,0,1-2.12,2.62h0c1.52.24,1.84,1.22,1.92,3a5.68,5.68,0,0,0,.37,2.24h-1.2a5,5,0,0,1-.29-2.21c0-1.9-.75-2.53-2.61-2.53H7.49v4.74H6.37Zm1.12,5h4.73c1.23,0,2.33-.45,2.33-2.1s-1.2-1.89-2.22-1.89H7.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.67,398.84h8.57v1H22.79v3.66H30v1h-7.2v4h7.59v1H21.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.93,398.84h1.12v4.56h7.79v-4.56H46v10.78H44.84v-5.19H37.05v5.19H35.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.32,406.3H53.64l-1.46,3.28H51l4.89-10.78h1.3l4.9,10.78h-1.3ZM56.49,400l-2.39,5.36h4.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.07,398.84H73.2c2.11,0,3,1.19,3,2.71a2.26,2.26,0,0,1-1.86,2.31h0a2.55,2.55,0,0,1,2.29,2.65c0,2.25-1.91,3.08-3.56,3.08h-6Zm1.11,4.68h4.43c1.51,0,2.48-.49,2.48-1.92s-.88-1.74-2.1-1.74H68.18Zm0,5.07h4.7c1.45,0,2.54-.57,2.54-2s-1-2-2.27-2h-5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.48,398.84H83.6v10.78H82.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.81,398.84h1.11v9.75h6.85v1H89.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,398.84h1.12v10.78H103Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.52,399.86h-4.23v-1h9.63v1h-4.23v9.76h-1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.64,406.3H125l-1.46,3.28h-1.21l4.89-10.78h1.3l4.9,10.78h-1.3Zm-2.8-6.35-2.43,5.36h4.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,399.86H136.5v-1h9.57v1h-4.23v9.76h-1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.28,398.84h1.12v10.78h-1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,398.56c3.06,0,5.85,1.87,5.85,5.67s-2.79,5.66-5.85,5.66-5.87-1.85-5.87-5.66S161,398.56,164.06,398.56Zm0,10.31a4.64,4.64,0,1,0-4.66-4.64,4.35,4.35,0,0,0,4,4.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.59,398.84h1.34l7.54,9.21h0v-9.21h1.12v10.78h-1.27l-7.58-9.21h0v9.21h-1.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.49,398.84h5.88c1.82,0,3.5.64,3.5,2.91a2.66,2.66,0,0,1-2.11,2.62h0c1.52.24,1.84,1.22,1.91,3a5.87,5.87,0,0,0,.38,2.24h-1.2a4.88,4.88,0,0,1-.29-2.21c0-1.9-.76-2.53-2.62-2.53H209.6v4.74h-1.11Zm1.11,5h4.73c1.23,0,2.33-.45,2.33-2.1s-1.19-1.89-2.22-1.89H209.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,398.84h8.58v1H225v3.66h7.19v1H225v4h7.58v1h-8.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,398.84h5.25c3.14,0,4.77,2,4.77,5.39,0,3-1.58,5.39-4.61,5.39H238Zm1.12,9.75h4.09c1.93,0,3.6-1,3.6-4.36,0-2.85-1.12-4.37-3.6-4.37h-4.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.08,398.84h8.58v1H255.2v3.66h7.19v1H255.2v4h7.58v1h-8.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.35,398.84h8.13v1h-6.93v3.66h6.61v1h-6.61v5.07h-1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.8,398.84h1.11v10.78H281.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.13,398.84h1.35l7.53,9.21h0v-9.21h1.12v10.78h-1.3l-7.58-9.21h0v9.21h-1.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.43,398.84H314v1h-7.46v3.66h7.19v1h-7.19v4h7.59v1h-8.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.7,398.84h5.24c3.14,0,4.77,2,4.77,5.39,0,3-1.59,5.39-4.6,5.39H319.7Zm1.12,9.75h4.07c1.94,0,3.62-1,3.62-4.36,0-2.85-1.12-4.37-3.62-4.37h-4.07Z",
    fill: "#fff"
  }))));
};

export default SvgFooterCasaLupitaLogo;